const SIZE_CLASS = {
  default: '',
  large: 'field--large',
};

const Field = ({
  id,
  label,
  labelFor,
  size = 'default',
  required = false,
  help = '',
  error = '',
  className = '',
  children,
}) => {
  // chyba prebiji napovedu
  const message = error || help;

  const classes = [
    'field',
    SIZE_CLASS[size] || SIZE_CLASS.default,
    error ? 'field--error' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Bez konkretniho ovladaciho prvku nema <label for> co adresovat.
  const LabelTag = labelFor ? 'label' : 'span';

  return (
    <div className={classes}>
      {label && (
        <LabelTag className="field__label" htmlFor={labelFor || undefined}>
          {label}
          {required && (
            <>
              {' '}
              <span className="field__req" aria-hidden="true">
                *
              </span>
            </>
          )}
        </LabelTag>
      )}

      {children}

      {message && (
        <p className="field__help" id={helpId(id)} role={error ? 'alert' : undefined}>
          {message}
        </p>
      )}
    </div>
  );
};

export const helpId = (id) => (id ? `${id}-help` : undefined);

export default Field;
